import VideoAds from './VideoAds';
export default VideoAds;
